// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"8244ca04","253":"55c257cb","324":"3ad5d5b7","521":"8e048b6e","547":"2671de03","869":"54f6ecf7"}[chunkId] + ".css";
};